<template>
  <div class="allClasses py-0">
    <div class="px-4">
      <div class="row">
        <div class="col-md-12">
          <skeleton-loading v-if="loading">
            <skeleton-square
              :box-properties="{
              height: '16px',
              width: '350px',
            }"
              :count="1"
            />
          </skeleton-loading>
          <div v-else>
            <h6 class="heading-small text-color-title mb-3"> Stripe Api Keys</h6>
            <div>
              <p class="p-0 m-0 pb-4 text-black">
                Activa o desactiva tus llaves API de Stripe (modo Producción o Prueba) desde esta sección.
              </p>
            </div>
            <div class="mt-2 d-flex align-items-center">
              <toggle-button
                :color="colors"
                :sync="true"
                :value="stripe_test_mode"
                name="report"
                @change="onChange($event)"
              />
              <p class="p-0 m-0 mb-1 ml-3  text-black">{{ statusText }}</p>
            </div>
            <h6 class="heading-small text-color-title mb-3"> Paypal Api Keys</h6>
            <div>
              <p class="p-0 m-0 pb-4 text-black">
                Activa o desactiva tus llaves API de Paypal (modo Producción o Prueba) desde esta sección.
              </p>
            </div>
            <div class="mt-2 d-flex align-items-center">
              <toggle-button
                :color="colors"
                :sync="true"
                :value="paypal_test_mode"
                name="report"
                @change="onPaypalChange($event)"
              />
              <p class="p-0 m-0 mb-1 ml-3  text-black">{{ statusPaypalText }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>


import { mapGetters } from 'vuex';
import axios from 'axios';
import config from '@/config/config';
import SkeletonSquare from '@/components/Skeleton/components/SkeletonSquare.vue';
import SkeletonLoading from '@/components/Skeleton/SkeletonLoading.vue';

export default {
  components: { SkeletonLoading, SkeletonSquare },
  data () {
    return {
      stripe_test_mode: false,
      paypal_test_mode: false,
      loading: true,
      colors: {
        checked: '#b7227e',
        unchecked: '#fbd6ed',
      },
    };
  },
  computed: {
    ...mapGetters(['getProfile', 'getInvoices', 'getCreditCardList']),
    statusText () {
      return this.stripe_test_mode
        ? 'Api Keys Prueba'
        : 'API Keys Producción';
    },
    statusPaypalText () {
      return this.paypal_test_mode
        ? 'Api Keys Prueba'
        : 'API Keys Producción';
    },
  },
  async mounted () {
    try {
      const config = await this.getConfigApiKey();
      this.stripe_test_mode = !!config.stripe_test_mode;
      this.paypal_test_mode = !!config.paypal_test_mode;

    } catch (error) {
      this.notify('error', 'Tenemos problemas para obtener las credenciales');

    }
    this.loading = false;
  },
  methods: {
    async getConfigApiKey () {
      const response = await axios.get(`${config.data.apiUrl}/admin/configuration/1`, {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('user-token'), // the token is a variable which holds the token
        },
      });

      return response.data;
    },
    async updateConfigApiKey (data) {
      const response = await axios.post(`${config.data.apiUrl}/admin/configuration/update`, {
        id: 1,
        ...data,
      }, {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('user-token'), // the token is a variable which holds the token
        },
      });

      return response.data;
    },

    async onChange () {
      try {
        await this.updateConfigApiKey({
          stripe_test_mode: !this.stripe_test_mode,
          paypal_test_mode: this.paypal_test_mode,
        });
        this.stripe_test_mode = !this.stripe_test_mode;
        this.notify('success', `Se activaron las credenciales de stripe${this.stripe_test_mode ? 'Prueba' : 'Producción'}`);
      } catch (error) {
        this.notify('error', 'Tenemos problemas para activar las credenciales');

      }

    },

    async onPaypalChange (event) {
      console.log({ event });
      try {
        await this.updateConfigApiKey({
          paypal_test_mode: !this.paypal_test_mode,
          stripe_test_mode: this.stripe_test_mode,
        });
        this.paypal_test_mode = !this.paypal_test_mode;
        this.notify('success', `Se activaron las credenciales de paypal ${this.paypal_test_mode ? 'Prueba' : 'Producción'}`);
      } catch (error) {
        this.notify('error', 'Tenemos problemas para activar las credenciales');

      }

    },

    notify (type, message) {
      this.$notify({
        type: type,
        verticalAlign: 'top',
        horizontalAlign: 'right',
        message: message,
      });
    },
  },
};
</script>

<style>
.tab-user-config.md-tabs.md-theme-default .md-tabs-navigation {
  border: 1px solid #ddd;
  border-radius: 10px;
}

.tab-user-config.md-tabs.md-alignment-left .md-tabs-navigation {
  justify-content: flex-start;
  width: fit-content;
}

.tab-user-config.md-tabs.md-theme-default
.md-tabs-navigation
.md-button.md-active {
  background: #b7227e;
  color: #fff !important;
  border-radius: 10px;
}

.tab-user-config.md-button.md-active {
  color: #fff !important;
}

.tab-user-config.md-button.md-tab-nav-button.md-theme-default.md-active {
  color: #fff !important;
  opacity: 1;
  transition: none;
  transform: none;
}

.tab-user-config .md-active .md-button-content {
  color: #fff !important;
}

.tab-user-config.style-config .md-tabs-indicator,
.tab-user-config.style-config .md-tabs-indicator.md-tabs-indicator-left,
.tab-user-config.style-config .md-tabs-indicator.md-tabs-indicator-right {
  background-color: transparent !important;
}

.tab-user-config.md-tabs.md-alignment-left .md-tabs-navigation {
  padding: 5px;
}

.multiselect__content-wrapper {
  position: absolute !important;
  top: 100% !important;
  bottom: auto !important;
}

.md-button,
.md-button-clean {
  -webkit-transition: none !important;
  transition: none !important;
}

@media screen and (max-width: 992px) {
  .user-view-config {
    padding-top: 100px !important;
  }
}
</style>
